/** @jsxImportSource @emotion/react */
import { theme } from '@app/styles/theme'
import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const rootStyles = (theme: Theme) => css`
  display: grid;
  grid-template-columns: 320px 1fr;
  height: calc(100vh - var(--layout-header-height, 120px));
  max-height: 100%;
  overflow: hidden;
  border: 1px solid ${theme.palette.neutral.light};
  background-color: ${theme.palette.white.main};
  border-radius: 12px;
`

export const leftPanelStyles = css`
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${theme.palette.neutral.dark};
  overflow: hidden;
`

export const cardsContainerStyles = css`
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const pinTrayStyles = (theme: Theme) => css`
  border-top: 1px solid ${theme.palette.neutral.dark};
  padding: 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.palette.neutral.light};
  flex-shrink: 0;
`

export const rightPanelStyles = (theme: Theme) => css`
  overflow: auto;
  background-color: ${theme.palette.background.default};
`
